var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.00008V2.50008C5.83333 2.27907 5.92113 2.06711 6.07741 1.91083C6.23369 1.75455 6.44565 1.66675 6.66667 1.66675H16.6667C16.8877 1.66675 17.0996 1.75455 17.2559 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V14.1667C17.5 14.3878 17.4122 14.5997 17.2559 14.756C17.0996 14.9123 16.8877 15.0001 16.6667 15.0001H14.1667V17.5001C14.1667 17.9601 13.7917 18.3334 13.3275 18.3334H3.33917C3.22927 18.3341 3.12033 18.313 3.0186 18.2714C2.91687 18.2299 2.82436 18.1686 2.74638 18.0912C2.6684 18.0137 2.60649 17.9216 2.56421 17.8202C2.52193 17.7188 2.50011 17.61 2.5 17.5001L2.5025 5.83342C2.5025 5.37341 2.8775 5.00008 3.34083 5.00008H5.83333ZM4.16833 6.66675L4.16667 16.6667H12.5V6.66675H4.16833ZM7.5 5.00008H14.1667V13.3334H15.8333V3.33341H7.5V5.00008ZM5.83333 9.16675H10.8333V10.8334H5.83333V9.16675ZM5.83333 12.5001H10.8333V14.1667H5.83333V12.5001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.3195e6bda52d355ac746c1b262616b50.svg";
export { ForwardRef as ReactComponent };